import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { useHistory } from "../../shared/hooks/useHistory";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { lifetimeIncomeCardStyles } from "./lifetime-income-card.styles";
import { lifeTimeCardImage } from "../../shared/consts/imgUrls";

export const LifetimeIncomeCard = () => {
  const history = useHistory();
  const classes = lifetimeIncomeCardStyles();
  const onHandleClick = () => history.push("/participant/retirementIncome");

  return (
    <Grid container className={classes.card} spacing={2}>
      <Grid item lg={3} xs={6}>
        <img alt="lifetime" src={lifeTimeCardImage} />
      </Grid>
      <Grid item lg={9} xs={6}>
        <Typography variant="h5" className={classes.title}>
          Lifetime Income
        </Typography>
        <Typography className={classes.description}>
          Check out the lifetime income calculator to see if you&lsquo;re
          retirement ready.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.upgradeMembership}
          endIcon={<ChevronRightIcon />}
          onClick={onHandleClick}
        >
          Check it out!
        </Button>
      </Grid>
    </Grid>
  );
};
